import * as ReactGA from 'react-ga'

const config = process.env.NODE_ENV === "production" ? "UA-98204892-1" : "UA-98204892-2";

ReactGA.initialize(config);

export default ReactGA;



// WEBPACK FOOTER //
// ./src/lib/GoogleAnalyticsWrapper.js